// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Rcp6B","container2":"styles_container2__8rg-i","footer":"styles_footer__Ds0lO","dataNotFound":"styles_dataNotFound__LePmH"};